import { useEffect } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";
import { VideoWithLoader } from "@/components/ui/video-loader";

interface VideoModalProps {
  src: string;
  onClose: () => void;
}

export function VideoModal({ src, onClose }: VideoModalProps) {
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleEsc);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handleEsc);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  return createPortal(
    <div
      className="fixed inset-0 z-[9999]"
      style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "env(safe-area-inset-top, 0px) env(safe-area-inset-right, 0px) env(safe-area-inset-bottom, 0px) env(safe-area-inset-left, 0px)" }}
    >
      <div
        className="fixed inset-0 bg-[#241d3a]/35 backdrop-blur-sm"
        onClick={onClose}
        style={{ zIndex: 0 }}
      />
      <div
        className="relative w-full max-w-3xl mx-4 rounded-3xl overflow-hidden border-2 border-[#2a2342] shadow-[5px_5px_0_rgba(42,35,66,0.18)] animate-modal-in bg-[#ece7f8]"
        style={{ zIndex: 1 }}
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-3 z-10 p-2 rounded-full bg-white/80 backdrop-blur-sm text-[#241d3a] hover:bg-white transition-all"
        >
          <X className="size-5" />
        </button>
        <VideoWithLoader
          src={src}
          className="w-full"
          style={{ maxHeight: "50vh" }}
          controls
          autoPlay
          loop
          playsInline
        />
      </div>
    </div>,
    document.body,
  );
}
